
// Utente
export interface IUtente {
  idUtente?: string
  login: string,
  nomeRuolo?: RuoloUtente,
  nomeCompleto: string,
  email: string,
  //serverLDAP: string,
  telefono?: string,
  cellulare?: string,
  idRuolo?: string
}

export interface IOperatore {
  idOperatore: string,
  idStazione: string,
  nomeCompletoOperatore: string
}

// Ruolo Utente
export interface IRuolo {
  id: number,
  descrizione: string // codiceRuolo in tutte le altre interface
}

export enum RuoloUtente {
  SUPERUSER = "SUPERUSER",
  OPERATORE = "OPERATORE",
  SUPERVISORE = "SUPERVISORE",
  GESTIONE_PAGAMENTI = "GESTIONE_PAGAMENTI",
  GESTIONE_CASSE = "GESTIONE_CASSE"
}